export const POPULAR_SEARCH_QUERY_OPERATION_NAME = 'KnowledgeDiscoveryPopularSearchQuery';

export const PopularSearchQuery = `
	query ${POPULAR_SEARCH_QUERY_OPERATION_NAME}($cloudId: String!, $searchQuery: String!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Popular Search Query") {
			popularSearchQuery(cloudId: $cloudId, searchQuery: $searchQuery) {
				__typename
				... on KnowledgeDiscoveryPopularSearchQuery {
        	isPopular
				}
				... on QueryError {
					message
					extensions {
						errorType
						statusCode
					}
				}
			}
		}
	}
`;
